import { render } from "./modal.vue?vue&type=template&id=04c0fec2"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=04c0fec2&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__